<template>
  <div class="week-statistics-tip">
    <span class="tip-text">注：本周日更新上周日至本周六数据</span>
  </div>
</template>

<script>
export default {
  name: 'WeekStatisticsTip'
}
</script>

<style lang="stylus" scoped>
.week-statistics-tip
  display: block
  margin-top: 8px
  
  .tip-text
    color: #ff0000
    font-size: 14px
    line-height: 1.5
</style>
